import { Field } from "formik";

export default function Controller({
  type = "text",
  name,
  onChange,
  errors,
  options = [],
}) {

  // Check for duplicate keys in options
  /*const values = options.map((item) => item.value);
  const hasDuplicates = values.some((value, index) => values.indexOf(value) !== index);
  if (hasDuplicates) {
    console.warn('Warning: Duplicate keys detected in options for Controller component:', options);
  }*/

  switch (type) {
    case "text":
    case "number":
      return (
        <>
          <Field
            type={type}
            className={`input-table ${errors[name] && "error"}`}
            name={name}
            onChange={onChange}
          />
          {errors[name] && (
            <div className="invalid-feedback d-block">{errors[name]}</div>
          )}
        </>
      );
    case "select":
      return (
        <>
          <Field
            as="select"
            className={`input-table ${errors[name] && "error"}`}
            name={name}
          >
            <option value="">Seleccionar opción</option>
            {options.map((item, index) => {
              // Corrected comment
              /* <option value={item.value} key={item.value}> */
              return (
                <option value={item.value} key={`${item.value}-${index}`}>
                  {item.label}
                </option>
              );
            })}
          </Field>
          {errors[name] && (
            <div className="invalid-feedback d-block">{errors[name]}</div>
          )}
        </>
      );
    default:
      return;
  }
}
